import { render } from "./RecursiveListCollection.vue?vue&type=template&id=64988b90&scoped=true&ts=true"
import script from "./RecursiveListCollection.vue?vue&type=script&lang=ts"
export * from "./RecursiveListCollection.vue?vue&type=script&lang=ts"

import "./RecursiveListCollection.vue?vue&type=style&index=0&id=64988b90&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64988b90"]])

export default __exports__